import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { AccordionSecurityReview } from '../../models/edit-tax-result-approval/accordion-security-review';

@Component({
  standalone: false,
  selector: 'gstar-comment-field',
  templateUrl: './comment-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentFieldComponent {
  isReadonly = input<boolean>(false);
  securityReview = input.required<AccordionSecurityReview>();
  textContent = input<string>('');
  title = input<string>('');
  update = output<string>();

  constructor() {}

  commentUpdate(comment: string): void {
    this.update.emit(comment);
  }
}
